import { Alert, AlertTitle, Link, Stack } from "@mui/material";

import { t } from "i18next";

const INSTRUCTION_LINK= "https://help.scanye.pl/pl/articles/14033589-instrukcja-polaczenia-z-ksef-dla-jdg"

export const SoleProprietorshipAlert = () => {
  return (
    <Alert severity="error" icon={false}>
      <Stack gap={2}>
          <AlertTitle sx={{ fontWeight: 700 }}>{t("soleProprietorshipAlert.title")}</AlertTitle>
        <Link
          href={INSTRUCTION_LINK}
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
          sx={{ fontWeight: 600, "&:hover": { color: "error.main" } }}
        >
          {t("soleProprietorshipAlert.linkText")}
        </Link>
      </Stack>
    </Alert>
  );
};
